import { render, staticRenderFns } from "./stack-bar.md?vue&type=template&id=4b0df918&"
import script from "./stack-bar.md?vue&type=script&lang=js&"
export * from "./stack-bar.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b0df918')) {
      api.createRecord('4b0df918', component.options)
    } else {
      api.reload('4b0df918', component.options)
    }
    module.hot.accept("./stack-bar.md?vue&type=template&id=4b0df918&", function () {
      api.rerender('4b0df918', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "website/views/demo/Bar/stack-bar.md"
export default component.exports